export enum RaumFirstLevelPage {
  LIST = 'list',
  EDIT = 'edit',
  DETAIL = 'detail',

  DUPLICATES = 'duplicates',
  PERMISSIONS = 'permissions',

  ACQUISITION = 'acquisition',
  REPORTING = 'reporting',
  INTENSIVE_COURSE_SINGLE = 'intensive-single',
  GRADUATION = 'graduation',

  DELETE = 'delete',
}

export enum RaumSecondLevelPage {
  // entity paths

  PARTNER = 'partner',
  FORM_OF_FINANCING = 'form-of-financing',
  PRODUCT = 'product',
  KPF = 'kpf',
  PERSON = 'person',
  CRM = 'crm',
  NOTE = 'note',
}

export enum RaumThirdLevelPage {
  // entity subtype paths
  STUDENT = 'student',
  EMPLOYEES = 'employee',

  IDEA = 'ideas',
}

// TODO: Will be removed with an Router update. Its a static class so the enums get resolved
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class RaumRoutes {
  static dashboard = `/`;

  // Lists
  static listPerson = `/${RaumFirstLevelPage.LIST}/${RaumSecondLevelPage.PERSON}`;
  static listStudent = `/${RaumFirstLevelPage.LIST}/${RaumSecondLevelPage.PERSON}/${RaumThirdLevelPage.STUDENT}`;
  static listEmployee = `/${RaumFirstLevelPage.LIST}/${RaumSecondLevelPage.PERSON}/${RaumThirdLevelPage.EMPLOYEES}`;
  static listCRM = `/${RaumFirstLevelPage.LIST}/${RaumSecondLevelPage.CRM}`;

  static listPartner = `/${RaumFirstLevelPage.LIST}/${RaumSecondLevelPage.PARTNER}`;
  static listFormOfFinancing = `/${RaumFirstLevelPage.LIST}/${RaumSecondLevelPage.FORM_OF_FINANCING}`;
  static listProduct = `/${RaumFirstLevelPage.LIST}/${RaumSecondLevelPage.PRODUCT}`;
  static listProductIdea = `/${RaumFirstLevelPage.LIST}/${RaumSecondLevelPage.PRODUCT}/${RaumThirdLevelPage.IDEA}`;
  static listKpf = `/${RaumFirstLevelPage.LIST}/${RaumSecondLevelPage.KPF}`;
  static listNote = `/${RaumFirstLevelPage.LIST}/${RaumSecondLevelPage.NOTE}`;

  // Edit
  static editPerson = `/${RaumFirstLevelPage.EDIT}/${RaumSecondLevelPage.PERSON}`;
  static editStudent = `/${RaumFirstLevelPage.EDIT}/${RaumSecondLevelPage.PERSON}/${RaumThirdLevelPage.STUDENT}`;
  static editEmployee = `/${RaumFirstLevelPage.EDIT}/${RaumSecondLevelPage.PERSON}/${RaumThirdLevelPage.EMPLOYEES}`;

  static editKpf = `/${RaumFirstLevelPage.EDIT}/${RaumSecondLevelPage.KPF}`;
  static editFormOfFinancing = `/${RaumFirstLevelPage.EDIT}/${RaumSecondLevelPage.FORM_OF_FINANCING}`;
  static editPartner = `/${RaumFirstLevelPage.EDIT}/${RaumSecondLevelPage.PARTNER}`;
  static detailPartner = `/${RaumFirstLevelPage.DETAIL}/${RaumSecondLevelPage.PARTNER}`;
  static editProduct = `/${RaumFirstLevelPage.EDIT}/${RaumSecondLevelPage.PRODUCT}`;
  static editNote = `/${RaumFirstLevelPage.EDIT}/${RaumSecondLevelPage.NOTE}`;

  // Misc
  static rolePermissionConfiguration = `/${RaumFirstLevelPage.PERMISSIONS}`;
  static dublicates = `/${RaumFirstLevelPage.DUPLICATES}`;
  static acquisition = `/${RaumFirstLevelPage.ACQUISITION}`;
  static reporting = `/${RaumFirstLevelPage.REPORTING}`;
  static reportingCreate = `/${RaumFirstLevelPage.REPORTING}/create`;
  static reportingEdit = `/${RaumFirstLevelPage.REPORTING}/edit`;
  static graduation = `/${RaumFirstLevelPage.GRADUATION}`;
  static intensiveCourseSingle = `/${RaumFirstLevelPage.INTENSIVE_COURSE_SINGLE}`;

  // Experimental
  static delete = `/${RaumFirstLevelPage.DELETE}`;
}
